<template>
  <div>
    <br />
    <button data-toggle="modal" data-target="#login-modal" type="button" class="btn btn-info">
      Cadastrar
      <i class="mdi mdi-plus"></i>
    </button>

    <div class="modal fade" id="login-modal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
      <form @submit.prevent>
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-body">
              <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
              <h4>Novo documento por tipo de usuário</h4>
              <br />
              <div class="form-group">
                <label for="cadastro_tipo">Tipo cadastro</label>
                <select class="form-control" id="cadastro_tipo" v-model="formData.cadastro_tipo">
                  <option value="pf">PF</option>
                  <option value="pj">PJ</option>
                </select>

                <span style="color: red" v-for="error in v$.cadastro_tipo.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>

              <div class="form-group">
                <label for="cadastro_tipo">Estado civil</label>
                <select class="custom-select rounded-0" id="estado_civil" v-model="formData.estado_civil">
                  <option value=""></option>
                  <option value="casado">Casado</option>
                  <option value="divorciado">Divorciado</option>
                  <option value="separado_judicialmente">Separado judicialmente</option>
                  <option value="solteiro">Solteiro</option>
                  <option value="solteiro_com_uniao_estavel">Solteiro com união estável</option>
                  <option value="solteiro_sem_uniao_estavel">Solteiro sem união estável</option>
                  <option value="uniao_estavel">União estável</option>
                  <option value="viuvo">Viuvo</option>
                </select>
              </div>
              <div class="form-group">
                <label for="tipo_doc">Tipo documento</label>
                <input class="form-control" id="tipo_doc" type="text" v-model="formData.tipo_doc" />

                <span style="color: red" v-for="error in v$.tipo_doc.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>

              <button @click="validateFields()" class="btn btn-primary btn-flat">
                Cadastrar
                <i class="fa fa-search"></i>
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import sweetAlert from "../../controller/sweetAlert";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "vue-loading-overlay/dist/vue-loading.css";
import Loading from "vue-loading-overlay";

import useVueLidate from "@vuelidate/core";
import { helpers } from "@vuelidate/validators";
import { required } from "../../locales/i18n.js";
import { computed, reactive } from "vue";

export default {
  mixins: [sweetAlert, Swal],

  props: [],

  components: [Loading],

  data() {
    return {
      nome: "",
      isLoading: false,
    };
  },

  setup() {
    const formData = reactive({
      cadastro_tipo: "",
      estado_civil: "",
      tipo_doc: "",
    });

    const rules = computed(() => {
      return {
        cadastro_tipo: { required },
        tipo_doc: { required },
      };
    });

    const v$ = useVueLidate(rules, formData);

    return { formData, v$ };
  },

  mounted() {},

  methods: {
    async validateFields() {
      const result = await this.v$.$validate();

      if (result) {
        this.create();
      }
    },

    create() {
      this.isLoading = true;

      let data = {
        cadastro_tipo: this.formData.cadastro_tipo,
        estado_civil: this.formData.estado_civil,
        tipodoc: this.formData.tipo_doc,
      };

      console.log("CRIANDO");
      console.log(data);

      axios
        .post(`/admin/documento_tipo_usuario/store`, data)
        .then((response) => {
          this.showSuccessMessage("Tipo documento cadastrado!");

          window.location.reload();
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
        });
    },
  },
};
</script>
